// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/thumbs-up.js';

import { paths } from '../generated/thumbs-up';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('thumbs-up', Original, paths);
